import type {FC} from 'react';
import clsx from 'clsx';

import {FeaturedLinks} from 'components/content-blocks/featured-links';
import {OrderForm} from 'components/content-blocks/order-form';
import {Text} from 'components/content-blocks/text';
import {TextWithImageSplit} from 'components/content-blocks/text-with-image-split';
import {Footer} from 'components/footer';
import {Header} from 'components/header';
import {Heading} from 'components/page-heading';

import type {FrontpageQueryResult} from '../frontpage/query';

import type {PageBySlugQueryResult} from './query';

interface Props {
	page: PageBySlugQueryResult | FrontpageQueryResult | null;
	isDraft: boolean;
}

export const Page: FC<Props> = ({page, isDraft}) => {
	const {content, heading} = page ?? {};

	const sections = content?.map((section) => {
		switch (section._type) {
			case 'textSection':
				return <Text key={section._key} section={section} isDraft={isDraft} />;
			case 'textWithImageSplit':
				return (
					<TextWithImageSplit key={section._key} section={section} isDraft={isDraft} />
				);
			case 'featuredLinks':
				return <FeaturedLinks key={section._key} section={section} isDraft={isDraft} />;
			case 'orderForm':
				return <OrderForm key={section._key} section={section} isDraft={isDraft} />;
			default:
				return null;
		}
	});

	const hideHeaderAndFooter = page?._type === 'page' && page?.hideHeaderAndFooter;

	return (
		<>
			{!hideHeaderAndFooter && <Header isDraft={isDraft} />}
			<main className={clsx('flex-1', 'bg-primary-extraLight')}>
				<Heading activeHeading={heading?.at(0)} />
				{sections}
			</main>
			{!hideHeaderAndFooter && <Footer isDraft={isDraft} />}
		</>
	);
};
